import momentTZ from 'moment-timezone';

/** wiz42 HQ (Tennessee) — final fallback when no timezone can be resolved. */
export const TENNESSEE_TZ = 'America/Chicago';

export type InviteTimezone = {
  target: 'client' | 'provider';
  clientTimezone?: string | null;
  providerTimezone?: string | null;
};

export type ResolveInput = {
  /** A deliberate caller override (e.g. a selected slot's tz). Highest priority. */
  explicit?: string | null;
  currentProviderTimezone?: string | null;
  invite?: InviteTimezone | null;
};

/**
 * Resolve the initial timezone (WST-764 §7).
 * Order: explicit -> currentProvider -> tz.guess() -> invite (client|provider) -> Tennessee.
 * currentProvider takes precedence over the browser guess; guess is used when there is no
 * current provider, and the invite/Tennessee fallbacks apply only when guess is unavailable.
 */
export function resolveInitialTimezone(input: ResolveInput = {}): string {
  if (input.explicit) return input.explicit;

  if (input.currentProviderTimezone) return input.currentProviderTimezone;

  const guess = momentTZ.tz.guess();
  if (guess) return guess;

  if (input.invite) {
    const inviteTz =
      input.invite.target === 'client' ? input.invite.clientTimezone : input.invite.providerTimezone;
    if (inviteTz) return inviteTz;
  }

  return TENNESSEE_TZ;
}
